<template>
  <div class="recruiter_dashboard widget_v2_1 widget_admin_dashboard" aria-label="Widget Admin Dashboard Page Content">

		   <div class="top-section row" style="max-width: 98%; margin-left: 2%;">
        <div class="page_content_container col-12">
          <div class="row">

            <div class="col-12">

              <template v-if="isDataLoaded">
                <template v-if="widget.uuid">

                  <div class="row msg_sec mt-4 pt-2">
                    <div class="col-12">
                      <div class="hd_txt" style="padding: 0px 35px;">
                        Hello {{userName}}!
                      </div>
                      <div class="ml-3" style="padding: 0px 35px;">
                        <p>Pick a program below to create your widget, and the preview will update in real time. Once you are happy with it, Click on “Get the Widget” to grab the code snippet and share with your webmaster. </p>
                      </div>
                    </div>
                  </div>

                  <div class="row pb-4 build_widget_sec">
                    <div class="col-1"></div>
                    <div class="col-10">

                      <div class="card" style="border: none; background: none;">
                        <div class="card-body" style="padding-top: 0px;">
                          <div class="row">
                            <div class="col-11 build_widget_info">

                              <div class="row sec_hd">
                                <div class="col-12">Build Your Widget</div>
                              </div>

                              <div class="row">
                                <div class="col-11" style="margin: auto;">
                                  <div class="row">
                                    <div class="col-2" style="max-width: 144px;">
                                      <div class="row align-items-center" style="height: 60px;">
                                        <div class="col-12">
                                          Select Program
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-10 program_select_fld">
                                      <div class="row align-items-center" style="height: 60px;">
                                        <div class="col-12">
                                          <v-select class="select-field" v-model="selectedMajor"
                                          :options="majors" label="name" :placeholder="'Select Any Program'" :clearable="false"></v-select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-4">
                                  <b-link class="custom-link" :to="{name: 'majorMinorList', params: {isWidgetAdminDash: true}}">Advanced Options</b-link>
                                  <!--<b-button class="lg" :disabled="isButtonDisabled" @click="previewWidget" aria-label="preview widget">Preview Widget</b-button>-->
                                </div>
                                <div class="col-8" style="text-align: right;">

                                </div>
                              </div>

                              <div class="row mt-4" v-if="!institution.enhancedWidget">
                                <div class="col-12">
                                  <div class="lnk_sec pt-2 pb-3">
                                    <b-link @click="showUpgradePopup">Upgrade my Free widget to trial the Enhanced Pragya Explore Widget</b-link>
                                  </div>
                                  <ul class="lst_1">
                                    <li>Enhanced Widget with regional data and calls to action</li>
                                    <li>Enrollment Counsellor Dashboard with downloadable student lists & learner activity insights</li>
                                    <li>Compare Widget editions & pricing</li>
                                  </ul>
                                </div>
                              </div>


                            </div>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="accordion_panel">
                    <template>
                      <div class="accordion" role="tablist">

                        <!--
                        <div class="accordion_crd">
                          <b-card-header header-tag="header" class="row crd_hd" role="tab"  block v-b-toggle.accordion-1 variant="info">
                            <div class="col-1 ic_container">
                              <div class="ic ic-expand_r"></div>
                              <div class="ic ic-collapse_r"></div>
                            </div>
                            <div class="col-10 title_txt">
                              Configure Widget
                            </div>
                          </b-card-header>
                          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body class="accordion_crd_content">



                            </b-card-body>
                          </b-collapse>
                        </div>
                        -->

                        <div class="accordion_crd" style="position: relative;">
                          <b-button style="position: absolute; top: 13px; right: 30px;" class="lg" :disabled="isButtonDisabled" @click="generateEmbedCode" aria-label="generate embed code">Get this Widget</b-button>
                          <b-card-header header-tag="header" class="row crd_hd" role="tab" block v-b-toggle.accordion-2 variant="info">
                            <div class="col-1 ic_container">
                              <div class="ic ic-expand_r"></div>
                              <div class="ic ic-collapse_r"></div>
                            </div>
                            <div class="col-10 title_txt">
                              <div class="row">
                                <div class="col-4">
                                  Widget Preview
                                </div>
                                <div class="col-6" style="text-align: center;">
                                  <template v-if="selectedMajor.name === 'All Programs'">
                                    Single All Programs Widget
                                  </template>
                                  <template v-if="selectedMajor.name && selectedMajor.name !== 'All Programs'">
                                    Program: {{selectedMajor.name}}
                                  </template>
                                </div>
                              </div>

                            </div>
                          </b-card-header>
                          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body class="accordion_crd_content">

                              <div class="card widget_preview_sec" style="border: none; background: none;">
                                <div class="card-body">
                                    <template v-if="selectedMajor.name && selectedMajor.name !== 'All Programs'">
                                      <!--
                                      <div class="note_msg">
                                        Note: This is a production widget, please don't submit a form on this widget.
                                      </div>
                                      -->
                                      <div class="widget_container">
                                        <widget-program-guide-career-prospects-detail :cipCode="selectedMajor.cipCode" :programGuideCode="selectedMajor.code" :key="programGuideKey" :institutionId="selectedMajor.institutionId" :majorTitle="selectedMajor.name" :introductionMessage="introductionMessage" :isWidgetAdminDash="true">
                                        </widget-program-guide-career-prospects-detail>
                                      </div>
                                    </template>

                                    <template v-if="selectedMajor.name && selectedMajor.name === 'All Programs'">
                                      <div class="program_name_sec">
                                        <div class="row title">
                                          <div class="col-2 pr-0" style="max-width: 144px; font-weight: normal;">
                                            <div class="row align-items-center" style="height: 60px;">
                                              <div class="col-12">
                                                Select Program:
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-10 select_fld">
                                            <div class="row align-items-center" style="height: 60px;">
                                              <div class="col-12">
                                                <v-select class="select-field" v-model="allSelectedMajor"
                                                :options="allProgramsMajors" label="name" :placeholder="'Select Any Program'" :clearable="false"></v-select>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <!--
                                      <div class="note_msg">
                                        Note: This is a production widget, please don't submit a form on this widget.
                                      </div>
                                      -->
                                      <div class="widget_container">
                                        <widget-program-guide-career-prospects-detail :cipCode="allSelectedMajor.cipCode" :programGuideCode="allSelectedMajor.code" :key="allProgramGuideKey" :institutionId="allSelectedMajor.institutionId" :majorTitle="allSelectedMajor.name" :introductionMessage="introductionMessage" :isWidgetAdminDash="true">
                                        </widget-program-guide-career-prospects-detail>
                                      </div>
                                    </template>
                                    <template v-if="!selectedMajor.name">
                                      <div class="text-center">
                                        Select a program to see the preview
                                      </div>
                                    </template>
                                </div>
                              </div>

                            </b-card-body>
                          </b-collapse>
                        </div>

                        <div class="accordion_crd">
                          <b-card-header header-tag="header" class="row crd_hd" role="tab" block v-b-toggle.accordion-3 variant="info" @click="hideProspectDashLoader">
                            <div class="col-1 ic_container">
                              <div class="ic ic-expand_r"></div>
                              <div class="ic ic-collapse_r"></div>
                            </div>
                            <div class="col-10 title_txt">
                              Your Prospects Dashboard
                            </div>
                          </b-card-header>
                          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body class="accordion_crd_content">

                              <recruiter-dashboard ref="recruiterDashboard" v-if="institution.enhancedWidget"></recruiter-dashboard>
                              <div class="prospects_dashboard_preview" v-if="!institution.enhancedWidget">
                                <div class="msg_layer">
                                  Prospects Student Dashboard is available with the full Pragya for Lead Nurturing widget.<br/>
                                  <b-link @click="showUpgradePopup">Upgrade to enable</b-link>
                                </div>
                                <div class="bg_layer"></div>
                              </div>

                            </b-card-body>
                          </b-collapse>
                        </div>

                        <div no-body class="accordion_crd">
                          <b-card-header header-tag="header" class="row crd_hd" role="tab" block v-b-toggle.accordion-4 variant="info">
                            <div class="col-1 ic_container">
                              <div class="ic ic-expand_r"></div>
                              <div class="ic ic-collapse_r"></div>
                            </div>
                            <div class="col-10 title_txt">
                              FAQ
                            </div>
                          </b-card-header>
                          <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                            <b-card-body class="accordion_crd_content">
                              <b-card-text>

                                <div class="row faq">
                                  <div class="col-12">

                                    <ol>

                                      <li>
                                        <span class="qus">
                                          Can I change the colors of the widget to match my website?
                                        </span>
                                        <span class="ans">
                                          Yes. This functionality is coming soon to the self service widget designer. If you would like to  enable it now - please contact us at <a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
                                        </span>
                                      </li>

                                      <li>
                                        <span class="qus">
                                          Can you show even more engagement points for prospective students?
                                        </span>
                                        <span class="ans">
                                          Absolutely ! Contact us for a demo of Pragya for Yield improvement.
                                          This includes Pathways from alumni,  additional academic and extracurricular
                                          content and more. To set up a demo - please contact us at
                                          <a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
                                        </span>
                                      </li>

                                      <li>
                                        <span class="qus">
                                          Can I invite the webmaster?
                                        </span>
                                        <span class="ans">
                                          Absolutely! Please contact us at
                                          <a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
                                        </span>
                                      </li>

                                      <li>
                                        <span class="qus">
                                          Can I enable multiple users to manage my institution account?
                                        </span>
                                        <span class="ans">
                                          Absolutely! Please contact us at
                                          <a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
                                        </span>
                                      </li>

                                      <li>
                                        <span class="qus">
                                          How many places can I put this widget?
                                        </span>
                                        <span class="ans">
                                          You can use the Pragya Career ROI Widget in as many website pages as you like!
                                          Please contact us at <a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
                                          if you would like help in including it in social media campaigns, or email campaigns.
                                        </span>
                                      </li>

                                      <li>
                                        <span class="qus">
                                          What does the widget cost after the Free trial is over?
                                        </span>
                                        <span class="ans">
                                          The Fre Widget will continue to be Free - at no charge to you or the
                                          student. We consider this our commitment to "pay it forward"
                                          to learners in higher education. If you have a trial for Pragya
                                          for Lead Capture - we will never automatically charge you. By default,
                                          the trial reverts to the Free widget after the trial period is complete.
                                          A representative may call you to discuss a subscription for Pragya for
                                          Lead Capture.
                                        </span>
                                      </li>

                                      <li>
                                        <span class="qus">
                                          What does the subscription include?
                                        </span>
                                        <span class="ans">
                                          Please check out the
                                          <b-link @click="showProductComparision">Product Comparison </b-link> Pragya for Lead capture
                                          includes the enhanced Career ROI widget, Enrollment lead capture
                                          and reporting & Insights. You only pay $10/ year for every new lead
                                          captured by the system.
                                        </span>
                                      </li>

                                    </ol>

                                  </div>
                                </div>

                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </div>

                      </div>
                    </template>
                  </div>

                  <div class="mt-5 pl-5 pr-5">
                    <div class="col-11 w-75" style="margin: auto;">


                    </div>
                  </div>

                </template>
                <template v-else>
                  <div class="wa_maiden_login">

                    <div class="row">
                      <div class="col-12">
                        <div class="row head">
                          <div class="col-3 logo_container">
                          </div>
                          <div class="col-6">
                            <div class="head_txt">Pragya Website Widgets</div>
                          </div>
                          <div class="col-3"></div>
                        </div>
                        <div class="row">
                          <div class="col-1"></div>
                          <div class="col-10 msg_sec">
                            <div class="hd_txt">
                              Hello {{userName}}!
                            </div>

                            <div class="top_txt_sec">
                              <p>One more step to go.</p>
                              <p>Your account is being validated. While this usually happens much sooner, it could sometimes take up to 2 business days.</p>
                              <p>You will receive an email from us, once its ready. Your Pragya widget will be customized to your institution's programs and can be placed anywhere on your website with no code.</p>
                              <p>Here is the sample widget</p>
                            </div>
                          </div>
                        </div>


                        <div class="row">
                          <div class="col-1"></div>
                          <div class="col-10">

                            <!--<div id="pragya"></div>-->
                            <div class="widget_container">
                              <widget-program-guide-career-prospects-detail :cipCode="selectedMajor.cipCode" :programGuideCode="selectedMajor.code" :key="programGuideKey" :institutionId="selectedMajor.institutionId" :majorTitle="selectedMajor.name" :introductionMessage="introductionMessage" :demoWidget="demoWidget">
                              </widget-program-guide-career-prospects-detail>
                            </div>

                          </div>
                        </div>

                        <div class="row lead_widget_features">
                          <div class="col-1"></div>
                          <div class="col-5">

                            <div class="list_container">
                              <p>You can try the enhanced Pragya Lead Nurture Widget free for the next three months. You can:</p>

                              <ul>
                                <li>Create unlimted instances of the widget for websites, email and social media campaigns</li>
                                <li>Showcase regional Job market data - Jobs in your area, and employers hiring</li>

                                <li>Enable Lead Capture and Calls to Action to engage prospective students</li>

                                <li>Access your own personalized dashbaord</li>
                                <li>Download list of prospective students captured via widget</li>
                                <li>Gain insights about prospect interests and career goal</li>
                                <li>Directly engage with prospective learners</li>
                              </ul>
                            </div>

                          </div>

                          <div class="col-5 img_container">
                            <img src="https://pragya2.s3.us-west-2.amazonaws.com/lead-widget-gif.gif" />
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>

                </template>
              </template>

            </div>
          </div>
        </div>


        <div class="modal_popup_container">
          <b-modal id="modal-widget-preview" ref="previewWidgetModal" hide-footer no-close-on-backdrop no-close-on-esc size="md" :header-bg-variant="'widget-popup-header'">
            <div slot="modal-header" class="header-section">
              <div class="popup_head_txt">
                <span><strong>Widget Preview :: {{selectedMajor.name}}</strong></span>
              </div>
              <div class="btn_container">
                <button class="btn_close" aria-label="close" @click="closePreviewWidget">
                <span class="ic-close"></span>
                </button>
              </div>
            </div>
            <div>
              <!--
              <widget-program-guide-career-prospects-detail :cipCode="selectedMajor.cipCode" :programGuideCode="selectedMajor.code" :key="programGuideKey" :institutionId="selectedMajor.institutionId" :majorTitle="selectedMajor.name" :introductionMessage="introductionMessage">
              </widget-program-guide-career-prospects-detail>
              -->
            </div>
          </b-modal>
        </div>


        <div>
          <b-modal class="get_widget_modal" id="modal-widget-embed-script" ref="embedWidgetModal" no-close-on-backdrop no-close-on-esc centered size="lg" :header-bg-variant="'widget-popup-header'">
            <div slot="modal-header" class="header-section w-100">
              <div class="popup_head_txt float-left">
                <label class="head_txt">Script to Embed in your Website</label>
              </div>
              <div class="btn_container float-right">
                <button class="btn_close" aria-label="close" @click="closeEmbedWidget">
                <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="fld_label mb-3">
              <label class="label">We show US National Data by default. Use the dropdowns below to choose either a state or a city as the default.</label>
            </div>
            <div class="fld_label">
             <label class="label">State or City (MSA)</label>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 filter_select_section">
             <b-input-group class="row frm_sec">
               <div class="row page_fld_section" style="width:100%">
               <div class="col-12 frm_fld_col">
                 <div class="row">
                   <div v-if="formattedGeoIdMap && formattedGeoIdMap.stateGeoIds" class="frm_fld state col-xl-6 col-lg-6">
                     <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
                       :options='formattedGeoIdMap.stateGeoIds' placeholder="Select or Search for a State" :class="!selectedState ? 'no_value_selected' : ''"></v-select>
                     <span class="fld_info">
                     <span v-if="disableSelectState">To select state clear the city selection first</span>
                     </span>
                   </div>
                   <div class="frm_label">
                   </div>
                   <div v-if="formattedGeoIdMap && formattedGeoIdMap.msaGeoIds" class="frm_fld city col-xl-6 col-lg-6">
                     <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
                       :options='formattedGeoIdMap.msaGeoIds' placeholder="Select or Search for a City" :class="!selectedMetroArea ? 'no_value_selected' : ''"></v-select>
                     <span class="fld_info">
                     <span v-if="disableSelectMetroArea">To select city clear the state selection first</span>
                     </span>
                   </div>
                 </div>
               </div>
             </div>
             </b-input-group>
            </div>

            <div class="pb-3">
              Simply copy the code below and paste it into a page on your website.
            </div>

            <div class="widget_code_container">
              <code>
                <textarea id="widget-code" rows="5" v-model="selectedEmbedScript"></textarea>
              </code>
            </div>

            <div slot="modal-footer" class="w-100">
              <b-button @click="copyCode" class="btn button-primary float-right">Copy to Clipboard</b-button>
            </div>

            <div class="pt-4">
              Would you like us to create an account for your webmaster?
              Send us a quick note <a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
            </div>
          </b-modal>

          <b-modal id="modal-widget-embed-script" ref="upgradeModal" hide-footer no-close-on-backdrop no-close-on-esc centered size="lg" :header-bg-variant="'widget-popup-header'">
            <div slot="modal-header" class="header-section w-100">
              <div class="popup_head_txt">
                <span><strong>Upgrade Free widget to trial the Enhanced Pragya Explore Widget</strong></span>
              </div>
              <div class="btn_container float-right" style="margin-top: 4px;">
                <button class="btn_close" aria-label="close" @click="closeUpgradePopup">
                <span class="ic-close"></span>
                </button>
              </div>
            </div>
            <div class="pl-4 pr-4">
              <p>
                Great! The Free Trial for the full Pragya Explore Widget is now active !
              </p>
              <ul>
                <li class="mb-2">Enhanced widget with regional data and Calls to Action</li>
                <li>Enrollment Counsellor Dashboard with downloadable student lists & learner activity insights</li>
              </ul>

              <div class="btn_container pt-2 mt-4 mb-3" style="text-align: right; width: 100%;">
                <button class="btn btn-primary" @click="upgradeToEnhancedWidget">Upgrade</button>
              </div>

            </div>
          </b-modal>
          <b-modal id="modal-widget-embed-script" ref="tosModal" hide-footer no-close-on-backdrop no-close-on-esc centered size="lg" :header-bg-variant="'widget-popup-header'">
            <div slot="modal-header" class="header-section w-100">
              <div class="popup_head_txt">
                <span><strong>Terms of Service</strong></span>
              </div>
              <!--
              <div class="btn_container float-right" style="margin-top: 4px;">
                <button class="btn_close" @click="closeTOSPopup()">
                  <span class="ic-close"></span>
                </button>
              </div>
              -->
            </div>
            <div class="pl-4 pr-4">
              <p>Thank you choosing to trial Pragya's Lead Nurture Widget. In order to continue, please read and accept our terms of service. If you have any questions, you can reach out at support@pragyasystems.com.</p>
              <p>
                <terms-of-service></terms-of-service>
              </p>

              <div class="btn_container pt-2 mt-4 mb-3" style="text-align: right; width: 100%;">
                <button class="btn btn-primary mb-3" @click="acceptTermsOfService">Accept Terms</button>
                <p class="mt-3">If your institution requires additional review or a hard copy of the contract. Click below</p>
                <button class="btn btn-primary" @click="acceptTermsOfServiceOffline">Accept Terms Offline</button>
              </div>

            </div>
          </b-modal>
        </div>


		  </div>


  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import WidgetProgramGuideCareerProspectsDetail from '../../programguide/components/WidgetProgramGuideCareerProspectsDetail'
  import RecruiterDashboard from './RecruiterDashboard'
  import TermsOfService from '../../user/components/TermsOfService'
  import { PACKAGE } from '../../../package_constants'

  export default {
    name: 'widget-admin-dashboard',
    components: {
      WidgetProgramGuideCareerProspectsDetail,
      RecruiterDashboard,
      TermsOfService
    },
    data: () => {
      return {
        tabIndex: 0,
        widget: {},
        selectedMajor: {},
        allSelectedMajor: {},
        programGuideKey: 0,
        allProgramGuideKey: 0,
        embedScript: '',
        selectedEmbedScript: '',
        introductionMessage: '',
        userObject: JSON.parse(localStorage.getItem('userobj')),
        isDataLoaded: false,
        majors: [],
        majorsToShow: [],
        allProgramsMajors: [],
        termsOfServiceSigned: false,
        demoWidget: false,
        key: '4e881971-2a42-4802-adb8-2c95f05d787c',
        secret: '975604b4-afeb-45a1-a5e8-2304a13bba2b',
        selectedState: '',
        selectedMetroArea: '',
        disableSelectState: false,
        disableSelectMetroArea: false
      }
    },
    mounted () {
      this.loadWidgetAdminDashboard()
    },
    methods: {
      ...mapActions([
        'loadWidgetDetail',
        'loadMajorMinors',
        'loadPragyaMajorMinors',
        'loadDemoWidgetMajorMinors',
        'loadUpgradeToEnhancedWidget',
        'loadInstitutionDetail',
        'loadAcceptTermsOfService',
        'loadAcceptTermsOfServiceOffline',
        'loadAuthenticateWidget',
        'loadWidgetDemoWidget',
        'loadLoginGuestUser',
        'loadInstitutionPackage',
        'loadGeoIds',
      ]),
      hideProspectDashLoader () {
        if (this.$refs.recruiterDashboard) {
          this.$refs.recruiterDashboard.hideLoader()
        }
      },
      linkClass (idx) {
        if (this.tabIndex === idx) {
          return ['tab-bg-light']
        } else {
          return ['tab-bg-dark']
        }
      },
      showLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.hide()
        }
      },
      async upgradeToEnhancedWidget () {
        this.isDataLoaded = false
        this.showLoader()
        await this.loadUpgradeToEnhancedWidget(this.userObject.institutionId)
        await this.loadInstitutionDetail()
        this.hideLoader()
        this.isDataLoaded = true
      },
      async acceptTermsOfService () {
        this.isDataLoaded = false
        this.showLoader()
        await this.loadAcceptTermsOfService(this.userObject.institutionId)
        await this.loadInstitutionDetail()
        this.hideLoader()
        this.isDataLoaded = true
      },
      async acceptTermsOfServiceOffline () {
        this.isDataLoaded = false
        this.showLoader()
        await this.loadAcceptTermsOfServiceOffline(this.userObject.institutionId)
        await this.loadInstitutionDetail()
        this.hideLoader()
        this.isDataLoaded = true
      },
      async loadWidgetAdminDashboard () {
        this.showLoader()
        let res = await this.loadWidgetDetail({uuid: this.userObject.institutionId, type: 'EXPLORE'})
        if (res) {
          this.widget = res
          this.embedScript = res.embeddableScript
          this.loadMajorMinors({page: 0, count: 5000, name: '', skipMinor: true}).then(result => {
            this.majors = this.majors.concat(result.content)
            if (this.majors.length === 0) {
              this.loadPragyaMajorMinors().then(res => {
                this.majors = this.majors.concat(res)
              })
            }
            this.majors.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
            this.majors.unshift({
              name: 'All Programs',
              institutionId: this.userObject.institutionId
            })
            if (this.majors.length > 0) {
              this.selectedMajor = this.majors[0]
            }
          })
        } else {
          this.includeFreeWidget()
        }
        await this.loadGeoIds()
        this.termsOfServiceSigned = this.institution.termsOfServiceSigned
        this.hideLoader()
        this.isDataLoaded = true
      },
      async includeFreeWidget () {
        this.demoWidget = await this.loadWidgetDemoWidget({key: this.key, secret: this.secret})
        this.loadAuthenticateWidget({key: this.key, secret: this.secret}).then(institutionId => {
          if (institutionId) {
            this.loadLoginGuestUser({institutionId: institutionId, isWidgetAdminDash: true}).then(token => {
              if (token) {
                this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
                  this.loadDemoWidgetMajorMinors({token: token, page: 0, count: 5000, name: ''}).then(result => {
                    this.majors = result.content
                    if (!this.isShowCategoryAsSeparateDropdownEnabled) {
                      this.majorsToShow = result.content
                    }
                    if (this.majors.length > 0) {
                      if (!this.isShowSelectProgramMessageEnabled) {
                        this.selectedMajor = this.majors[0]
                      }
                    } else {
                      this.loadPragyaMajorMinors().then(res => {
                        this.majors = res
                        this.majorsToShow = res
                        if (this.majors.length > 0) {
                          if (!this.isShowSelectProgramMessageEnabled) {
                            this.selectedMajor = this.majors[0]
                          }
                        }
                      })
                    }
                  })
                })
              }
            })
          }
        })
      },
      previewWidget () {
        this.programGuideKey = this.programGuideKey + 1
        this.$refs.previewWidgetModal.show()
      },
      closePreviewWidget () {
        this.$refs.previewWidgetModal.hide()
      },
      generateEmbedCode (majorMinor) {
        this.selectedEmbedScript = this.embedScript
        if (this.selectedMajor.name !== 'All Programs') {
          this.selectedEmbedScript = this.selectedEmbedScript.replace('52.0201', this.selectedMajor.cipCode)
          this.selectedEmbedScript = this.selectedEmbedScript.replace('BBA', this.selectedMajor.code)
        } else {
          this.selectedEmbedScript = this.selectedEmbedScript.replace('52.0201', '')
          this.selectedEmbedScript = this.selectedEmbedScript.replace('BBA', '')
        }

        if (this.selectedState) {
          this.selectedEmbedScript = this.selectedEmbedScript.replace('state=""', 'state="' + this.selectedState.id + '"')
        }

        if (this.selectedMetroArea) {
          this.selectedEmbedScript = this.selectedEmbedScript.replace('msa=""', 'msa="' + this.selectedMetroArea.id + '"')
        }
        this.$refs.embedWidgetModal.show()
      },
      closeEmbedWidget () {
        this.selectedEmbedScript = ''
        this.$refs.embedWidgetModal.hide()
      },
      copyCode () {
        $('#widget-code').select()
        document.execCommand('copy')
      },
      showUpgradePopup () {
        this.$refs.upgradeModal.show()
      },
      closeUpgradePopup () {
        this.$refs.upgradeModal.hide()
      },
      showTOSPopup () {
        this.$refs.tosModal.show()
      },
      closeTOSPopup () {
        this.$refs.tosModal.hide()
      },
      showProductComparision() {
        window.open("/vue/#/widget/register",'_blank').focus();
      },
      formatOptionsForVSelect (map) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          formatted.push({id: key, label: map[key]})
        })
        formatted.sort((a, b) => (a.id >= b.id) ? 1 : -1)
        return formatted
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution,
        'permission': state => state.user.permission,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'geoIdMap': state => state.career.geoIdMap,
      }),
      userName () {
        return this.userObject.firstName
      },
      isButtonDisabled () {
        let keys = Object.keys(this.selectedMajor)
        return (keys.length === 0)
      },
      isShowSelectProgramMessageEnabled () {
        let showMessage = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_SELECT_PROGRAM_MESSAGE]
        return showMessage && showMessage.enabled
      },
      selectProgramLabel () {
        let label = 'Start exploring careers by selecting a program and/or concentration/major above.'
        let showMessage = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_SELECT_PROGRAM_MESSAGE]
        if (showMessage && showMessage.enabled) {
          label = showMessage.label
        }
        return label
      },
      programLabel () {
        let label = 'Program'
        let programFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
        if (programFeature && programFeature.enabled && programFeature.label) {
          label = programFeature.label
        }
        return label
      },
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
        }
        return formattedMap
      }
    },
    watch: {
      selectedState (newState) {
        if (!newState) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
        } else {
          this.disableSelectState = false
          this.disableSelectMetroArea = true
          this.disableSelectCounty = true
        }
        this.generateEmbedCode()
      },
      selectedMetroArea (newMSA) {
        this.generateEmbedCode()
        if (!newMSA) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = false
        }
      },
      selectedMajor (newSelectedMajor) {
        this.cipCode = this.selectedMajor.cipCode
        this.programGuideCode = this.selectedMajor.code
        this.programGuideKey = this.programGuideKey + 1
        if (newSelectedMajor.name === 'All Programs') {
          this.majors.forEach((item, i) => {
            if (item.name !== 'All Programs') {
              this.allProgramsMajors.push(item)
            }
          })
          this.allSelectedMajor = this.allProgramsMajors[0]
        } else {
          this.allProgramsMajors = []
          this.allSelectedMajor = {}
        }
      },
      allSelectedMajor (newAllSelectedMajor) {
        this.allProgramGuideKey = this.allProgramGuideKey + 1
      },
      'institution.termsOfServiceSigned' (newTermsOfServiceSigned) {
        this.termsOfServiceSigned = newTermsOfServiceSigned
      },
      termsOfServiceSigned () {
        if (!this.termsOfServiceSigned && this.institution.enhancedWidget) {
          this.showTOSPopup()
        }
      },
      'institution.enhancedWidget' () {
        if (!this.termsOfServiceSigned && this.institution.enhancedWidget) {
          this.showTOSPopup()
        }
      }
    }
  }
</script>

<style>
  .tab-bg-light {
    color: #fff !important;
    background-color: #76929f !important;
  }

  .tab-bg-dark {
    color: #fff !important;
    background-color: #157099 !important;
  }

  .custom-link {
    color: #157099;
  }

  .popup_head_txt {
    font-size: 1.4rem;
    font-weight: 600;
    float: left;
    color: #323232;
  }

  .bg-widget-popup-header {
    background: #f5f5f5 !important;
  }

  .selected-tag {
    max-width: calc(100% - 18px);
  }

  .v-select input {
    border: none !important;
  }

  .modal_popup_container .modal .modal-dialog {
    max-width: calc(100% - 300px);
    height: calc(100vh - 50px);
    min-height: 200px;
  }

  .usr_verification_popup .modal .modal-dialog {
    width: 75%;
    height: auto;
  }
  .img_container {
    text-align: center;
  }
  .img_container img {
    width: 90%;
  }
  .list_container li {
    margin-bottom: 10px;
  }
  .select_fld {
    font-weight: normal;
    max-width: calc(100% - 155px);
    flex: 0 0 calc(100% - 155px);
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/WidgetAdminDashboard.vue